export default __webpack_public_path__ + "static/media/delete-outline-drawer.094c1428.svg";